{
    "link" : {
        "imprint": "Impressum",
        "data privacy": "Datenschutz",
        "used licenses": "Verwendete Lizenzen"
    }
}
